import * as React from 'react';
export var HeaderMenu = function (_a) {
    var children = _a.children;
    return (React.createElement("ul", { className: "row header-rows", id: "navbar-menu-content" }, children));
};
//# sourceMappingURL=HeaderMenu.js.map